import {
  CreateUpsellDiscountDocument,
  GetUpsellDiscountsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

type Props = {
  moduleName: string
  moduleSlug: string
}

const useModuleDiscount = ({ moduleName, moduleSlug }: Props) => {
  const {
    data: discountsData,
    loading: discountsLoading,
    refetch,
  } = useQuery(GetUpsellDiscountsDocument)

  const moduleDiscounts = discountsData?.upsell?.upsellDiscountsConnection?.nodes
  const discount = moduleDiscounts?.find((discount_item) => discount_item.module === moduleName)

  const [createUpsellDiscount] = useMutation(CreateUpsellDiscountDocument, {
    extractorFn: (data) => data.upsellMutations.createUpsellUpsellDiscount,
  })

  const createDiscount = () => {
    return createUpsellDiscount({
      variables: {
        discountType: 'abandoned_cart',
        module: moduleName,
        moduleName: moduleName,
        moduleSlug: moduleSlug,
      },
    })
  }

  return {
    discount,
    createDiscount,
    discountsLoading,
    refetchDiscounts: refetch,
  }
}

export default useModuleDiscount
